










































import 'reflect-metadata'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import CopyText from '@/components/misc/CopyText.vue'
import { toDCM } from '@/helper'
import Loader from '@/components/misc/Loader.vue'
import Tooltip from '@/components/rows/Tooltip.vue'
import {
    getEVMAddressBalance,
    IEVMAddressBalanceParams,
} from '@/services/evmAddressBalance'

@Component({
    components: {
        Tooltip,
        CopyText,
    },
    filters: {
        toDCM,
    },
})
export default class EVMAddressSummary extends Vue {
    @Prop() address!: string
    loading = true
    accountBalance: number | null = null

    copy() {
        navigator.clipboard.writeText(this.address)
        this.$store.dispatch('Notifications/add', {
            title: 'Copied',
            message: 'Copied to clipoard.',
        })
    }

    mounted() {
        this.fetchData()
    }

    get USDPrice() {
        return parseInt(this.$store.state.prices?.usd || '0')
    }

    get inUSD() {
        if (!this.accountBalance) return 0

        return this.accountBalance * this.USDPrice
    }

    async fetchData() {
        this.loading = true
        const params: IEVMAddressBalanceParams = {
            address: this.address,
        }
        const res = await getEVMAddressBalance(params)
        this.accountBalance = toDCM(parseInt(res.data.result, 16), 18)
        this.loading = false
    }
}
